import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store"
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import api from "./api";
import bus from "./bus";
import InitController from "./utils/InitController"
import 'vue-select/dist/vue-select.css';
import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueSkycons, {
  color: "#1e88e5",
});


// import NProgress from "nprogress";
// NProgress.configure({ parent: '#loader' });

Vue.prototype.$bus = bus;
Vue.prototype.$api = api;
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuebar);

//Definir inicio de sesion y otras cosas
InitController.start();

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
new Vue({
  vuetify,
  store : store,
  router,
  render: (h) => h(App),
}).$mount("#app");